/* 938 ocp-header v1.5 — поведение шапки витрины (sections/ocp-header.liquid). */
(function () {
  var mobile = window.matchMedia('(max-width: 989px)');

  /* sticky-header v1.0 — копия поведения Dawn «прятать при прокрутке вниз»: класс Dawn живёт
     в header.liquid и в сборку не попадает, когда группа шапки рендерит ocp-header. */
  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', class extends HTMLElement {
      connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.alwaysSticky = this.getAttribute('data-sticky-type') === 'always';
        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');
        this.setHeaderHeight();
        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
        if (this.getAttribute('data-sticky-type') === 'none') return;
        if (this.alwaysSticky) this.header.classList.add('shopify-section-header-sticky');
        this.onScrollHandler = this.onScroll.bind(this);
        this.addEventListener('preventHeaderReveal', () => (this.preventReveal = true));
        window.addEventListener('scroll', this.onScrollHandler, false);
        new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        }).observe(this.header);
      }
      disconnectedCallback() {
        if (this.onScrollHandler) window.removeEventListener('scroll', this.onScrollHandler);
      }
      setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', this.header.offsetHeight + 'px');
      }
      onScroll() {
        var top = window.pageYOffset || document.documentElement.scrollTop;
        var bounds = this.headerBounds || { top: 0, bottom: 0 };
        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
        if (top > this.currentScrollTop && top > bounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          requestAnimationFrame(this.hide.bind(this));
        } else if (top < this.currentScrollTop && top > bounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            clearTimeout(this.isScrolling);
            this.isScrolling = setTimeout(() => (this.preventReveal = false), 66);
            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (top <= bounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }
        this.currentScrollTop = top;
      }
      hide() {
        if (this.alwaysSticky) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        closePopups();
      }
      reveal() {
        if (this.alwaysSticky) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }
      reset() {
        if (this.alwaysSticky) return;
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }
    });
  }

  /* ocp-header-raise v1.0 — пока открыто меню, панель или раздел, шапка выше чата и кнопки cookies;
     выдача поиска закрывается, чтобы не висела под меню. */
  var section = document.querySelector('.section-header');
  function syncRaised() {
    var open = locs.some(function (l) { return !l.panel.hidden; }) || (drawer && drawer.open) || dropdowns.some(function (d) { return d.open; });
    if (section) section.classList.toggle('ocp-hd-raised', open);
  }
  function closeSearch() {
    var ps = document.querySelector('.ocp-hd__search');
    if (ps && ps.isOpen && typeof ps.close === 'function') ps.close();
  }

  /* ocp-header-locale v1.2 — панели «страна доставки» и «язык» (821: две кнопки, как у Amazon). */
  var locs = Array.prototype.slice.call(document.querySelectorAll('[data-ocp-loc]')).map(function (root) {
    return { root: root, btn: root.querySelector('.ocp-hd-loc__btn'), panel: root.querySelector('.ocp-hd-loc__panel') };
  });
  function locOpen(l) {
    closeDropdowns();
    closeSearch();
    locClose(false);
    l.panel.hidden = false;
    l.btn.setAttribute('aria-expanded', 'true');
    syncRaised();
    var first = l.panel.querySelector('input:checked') || l.panel.querySelector('input, select, button');
    if (first) first.focus({ preventScroll: true });
  }
  function locClose(returnFocus, only) {
    locs.forEach(function (l) {
      if ((only && l !== only) || l.panel.hidden) return;
      l.panel.hidden = true;
      l.btn.setAttribute('aria-expanded', 'false');
      if (returnFocus) l.btn.focus();
    });
    syncRaised();
  }
  locs.forEach(function (l) {
    l.btn.addEventListener('click', function () { l.panel.hidden ? locOpen(l) : locClose(false, l); });
    l.root.querySelector('[data-ocp-loc-close]').addEventListener('click', function () { locClose(true, l); });
    l.root.addEventListener('keydown', function (e) { if (e.key === 'Escape') locClose(true, l); });
  });
  var langForm = document.getElementById('ocp-loc-form');
  if (langForm) langForm.addEventListener('submit', function () {
    var lang = this.querySelector('input[name="locale_code"]:checked');
    try { if (lang) localStorage.setItem('ocp-lang-choice', lang.value); } catch (e) {}
  });
  /* ocpSetLocale v2.0 — прежний контракт для пилюли языка в подвале: та же форма, страна прежняя. */
  window.ocpSetLocale = function (code) {
    var form = document.getElementById('ocp-loc-form');
    if (!form) return;
    try { localStorage.setItem('ocp-lang-choice', code); } catch (e) {}
    var radio = form.querySelector('input[name="locale_code"][value="' + code + '"]');
    if (radio) radio.checked = true;
    else form.querySelector('input[name="locale_code"]').value = code;
    form.submit();
  };

  /* ocp-header-dropdown v1.1 — разделы каталога: на десктопе выпадающая сетка, на телефоне меню «Все». */
  var dropdowns = Array.prototype.slice.call(document.querySelectorAll('[data-ocp-dd]'));
  function closeDropdowns(except) {
    dropdowns.forEach(function (d) { if (d !== except) d.open = false; });
  }
  dropdowns.forEach(function (d) {
    var summary = d.querySelector('summary');
    summary.addEventListener('click', function (e) {
      if (mobile.matches) {
        e.preventDefault();
        drawerOpen(summary, 'ocp-mn-' + summary.getAttribute('data-ocp-group'));
        return;
      }
      locClose(false);
      closeDropdowns(d);
    });
    d.addEventListener('toggle', syncRaised);
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && d.open) { d.open = false; summary.focus(); }
    });
  });

  /* ocp-header-drawer v2.0 (923) — меню «Все»: модальный <dialog>, панели уровней, фильтр марок, смахивание влево закрывает. */
  var drawer = document.getElementById('ocp-hd-drawer');
  var sheet = drawer && drawer.querySelector('.ocp-hd__sheet');
  var scrim = drawer && drawer.querySelector('.ocp-hd__scrim');
  var menu = drawer && drawer.querySelector('[data-ocp-menu]');
  var root = menu && menu.querySelector('[data-ocp-panel="root"]');
  var openers = Array.prototype.slice.call(document.querySelectorAll('[data-ocp-drawer-open]'));
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');
  var lastOpener = null;
  var trail = [];
  var closeTimer = 0;
  var escAt = -1;

  function panelShow(panel, behind) {
    menu.querySelectorAll('[data-ocp-panel]').forEach(function (p) {
      p.classList.toggle('is-current', p === panel);
      p.classList.toggle('is-behind', p === behind);
      p.inert = p !== panel;
    });
    menu.querySelectorAll('[data-ocp-go]').forEach(function (b) {
      b.setAttribute('aria-expanded', String(b.getAttribute('data-ocp-go') === panel.id));
    });
  }
  function panelGo(id, from) {
    var panel = document.getElementById(id);
    if (!panel) return;
    trail.push(from);
    panel.scrollTop = 0;
    panelShow(panel, root);
    var back = panel.querySelector('[data-ocp-back]');
    if (back) back.focus({ preventScroll: true });
  }
  function panelBack() {
    var from = trail.pop();
    panelShow(root);
    if (from) from.focus({ preventScroll: true });
  }
  function panelReset(id) {
    trail = [];
    menu.classList.add('ocp-mn--instant');
    menu.querySelectorAll('[data-ocp-filter]').forEach(function (input) {
      if (input.value) { input.value = ''; makesFilter(input); }
    });
    panelShow(root);
    if (id) panelGo(id, menu.querySelector('[data-ocp-go="' + id + '"]'));
    void menu.offsetWidth;
    menu.classList.remove('ocp-mn--instant');
  }

  /* ocp-menu-cars v1.0 (932) — машинки марок, как ocp-brand-cars на главной: SVG встраивается (линии и фары задаёт CSS),
     проверка элементов та же; грузятся при появлении в открытой панели, не больше 4 запросов разом. */
  var carQueue = [], carBusy = 0, carsReady = false;
  function carLoad(art) {
    return fetch(art.getAttribute('data-car-url'), { credentials: 'omit', cache: 'force-cache' }).then(function (r) {
      if (!r.ok) throw new Error('car_asset_unavailable');
      return r.text();
    }).then(function (text) {
      var doc = new DOMParser().parseFromString(text, 'image/svg+xml'), svg = doc.documentElement;
      if (svg.localName !== 'svg' || doc.querySelector('parsererror')) throw new Error('invalid_car_svg');
      [svg].concat(Array.prototype.slice.call(svg.querySelectorAll('*'))).forEach(function (node) {
        if (['svg', 'path', 'g', 'circle', 'title', 'desc'].indexOf(node.localName) < 0) throw new Error('unexpected_car_element');
        Array.prototype.forEach.call(node.attributes, function (a) {
          if (/^on/i.test(a.name) || /^(?:href|style)$/i.test(a.name)) throw new Error('unexpected_car_attribute');
        });
      });
      svg.querySelectorAll('title,desc').forEach(function (n) { n.remove(); });
      ['role', 'aria-label'].forEach(function (a) { svg.removeAttribute(a); });
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      art.replaceChildren(document.importNode(svg, true));
    });
  }
  function carRun(art) {
    carBusy++;
    carLoad(art).catch(function () { art.setAttribute('data-car-failed', ''); }).then(function () { carBusy--; carDrain(); });
  }
  function carDrain() {
    while (carBusy < 4 && carQueue.length) carRun(carQueue.shift());
  }
  var carSeen = 'IntersectionObserver' in window && new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      carSeen.unobserve(e.target);
      carQueue.push(e.target);
      carDrain();
    });
  }, { rootMargin: '160px 0px' });
  function carsWatch() {
    if (carsReady) return;
    carsReady = true;
    drawer.querySelectorAll('[data-car-url]').forEach(function (art) { if (carSeen) carSeen.observe(art); else carQueue.push(art); });
    carDrain();
  }
  function carWatch(art) {
    if (!carsReady || art.querySelector('svg') || !art.hasAttribute('data-car-url')) return;
    if (carSeen) carSeen.observe(art); else { carQueue.push(art); carDrain(); }
  }

  /* ocp-menu-rank v1.0 (938) — марки в том же порядке, что на главной (ocp-brand-cars v838): точные счётчики
     /collections.json, та же проверка набора; при сбое или неполном наборе остаётся порядок Liquid. Запрос — при
     первом наведении или открытии меню, ответ браузер берёт из кеша главной. */
  var rankStarted = false;
  function makesRank() {
    if (rankStarted || !menu || !menu.querySelector('.ocp-mn__makes')) return;
    rankStarted = true;
    var ctl = 'AbortController' in window ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 2500);
    fetch('/collections.json?limit=250', { credentials: 'omit', cache: 'default', signal: ctl ? ctl.signal : undefined })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var map = new Map();
        var rows = (data && data.collections) || [];
        for (var i = 0; i < rows.length; i++) {
          var c = rows[i];
          if (typeof c.handle !== 'string' || !Number.isSafeInteger(c.products_count) || c.products_count < 0 || map.has(c.handle)) return;
          map.set(c.handle, c.products_count);
        }
        if (map.size) makesApply(map);
      })
      .catch(function () {})
      .then(function () { clearTimeout(timer); });
  }
  function makeHandle(a) { return a.getAttribute('href').split('?')[0].split('/').pop(); }
  function makesApply(counts) {
    var list = menu.querySelector('.ocp-mn__makes');
    var items = Array.prototype.slice.call(list.children);
    if (!items.every(function (li) { return counts.has(makeHandle(li.querySelector('a'))); })) return;
    items.map(function (li, i) { return { li: li, i: i, n: counts.get(makeHandle(li.querySelector('a'))) }; })
      .sort(function (a, b) { return b.n - a.n || a.i - b.i; })
      .forEach(function (x) { list.appendChild(x.li); });
    var tops = menu.querySelector('.ocp-mn__tops');
    if (!tops) return;
    var have = {};
    Array.prototype.forEach.call(tops.children, function (li) { have[li.querySelector('a').getAttribute('href')] = li; });
    var want = Array.prototype.slice.call(list.children, 0, tops.children.length).map(function (li) {
      var a = li.querySelector('a'), href = a.getAttribute('href');
      if (have[href]) return have[href];
      var tile = document.createElement('li'), link = document.createElement('a'), name = document.createElement('span');
      var car = a.querySelector('.ocp-mn__car').cloneNode(true);
      link.className = 'ocp-mn__top';
      link.href = href;
      if (a.hasAttribute('aria-current')) link.setAttribute('aria-current', 'page');
      name.textContent = a.querySelector('span:last-child').textContent;
      link.append(car, name);
      tile.appendChild(link);
      carWatch(car);
      return tile;
    });
    tops.replaceChildren.apply(tops, want);
  }

  function fold(s) { return s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
  function makesFilter(input) {
    var list = document.getElementById(input.getAttribute('aria-controls'));
    var none = list.nextElementSibling;
    var q = fold(input.value);
    var hits = [];
    list.querySelectorAll('li').forEach(function (li) {
      if (li.ocpName == null) li.ocpName = ' ' + fold(li.getAttribute('data-name'));
      li.hidden = !!q && li.ocpName.indexOf(' ' + q) < 0;
      if (!li.hidden) hits.push(li);
    });
    none.hidden = hits.length > 0;
    var link = none.querySelector('a');
    link.href = link.getAttribute('data-base') + encodeURIComponent(input.value.trim());
    return hits;
  }

  function drawerOpen(opener, panelId) {
    clearTimeout(closeTimer);
    lastOpener = opener;
    closeDropdowns();
    locClose(false);
    closeSearch();
    makesRank();
    carsWatch();
    if (!drawer.open) drawer.showModal();
    panelReset(panelId);
    var chat = drawer.querySelector('[data-ocp-chat]');
    if (chat) chat.closest('li').hidden = typeof window.ocpChatToggle !== 'function';
    document.documentElement.classList.add('ocp-hd-lock');
    openers.forEach(function (o) { o.setAttribute('aria-expanded', 'true'); });
    void sheet.offsetWidth;
    drawer.classList.add('is-open');
    if (!panelId) sheet.focus({ preventScroll: true });
  }
  function drawerDone() {
    clearTimeout(closeTimer);
    drawer.classList.remove('is-open', 'is-dragging');
    sheet.style.transform = '';
    scrim.style.opacity = '';
    document.documentElement.classList.remove('ocp-hd-lock');
    openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
    syncRaised();
  }
  /* then — действие после закрытия (чат, панель страны или языка): фокус вне <dialog> доступен только после close(). */
  function drawerClose(then) {
    if (!drawer.open || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    sheet.style.transform = '';
    scrim.style.opacity = '';
    closeTimer = setTimeout(function () {
      drawer.close();
      drawerDone();
      if (typeof then === 'function') then();
      else if (lastOpener && lastOpener.offsetParent !== null) lastOpener.focus({ preventScroll: true });
    }, still.matches ? 0 : 300);
  }
  function drawerEscape() {
    var input = document.activeElement;
    if (input && input.matches('[data-ocp-filter]') && input.value) { input.value = ''; makesFilter(input); return; }
    if (trail.length) panelBack(); else drawerClose();
  }

  if (drawer && typeof drawer.showModal === 'function') {
    panelShow(root);
    openers.forEach(function (o) {
      o.addEventListener('click', function () { drawerOpen(o); });
      ['pointerenter', 'focus', 'touchstart'].forEach(function (t) { o.addEventListener(t, makesRank, { passive: true }); });
    });
    drawer.addEventListener('close', drawerDone);
    /* Esc и «Назад» Android: сначала уровень вверх, потом закрытие с анимацией. Неотменяемый cancel закроет диалог сам — состояние сбросит close. */
    drawer.addEventListener('cancel', function (e) {
      if (!e.cancelable) return;
      e.preventDefault();
      if (e.timeStamp - escAt > 50) drawerEscape();
    });
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      e.preventDefault();
      escAt = e.timeStamp;
      drawerEscape();
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-ocp-drawer-close]')) { drawerClose(); return; }
      var go = e.target.closest('[data-ocp-go]');
      if (go) { panelGo(go.getAttribute('data-ocp-go'), go); return; }
      if (e.target.closest('[data-ocp-back]')) { panelBack(); return; }
      if (e.target.closest('[data-ocp-chat]')) { drawerClose(function () { window.ocpChatToggle(true); }); return; }
      var loc = e.target.closest('[data-ocp-loc-open]');
      if (!loc) return;
      var ship = loc.getAttribute('data-ocp-loc-open') === 'ship';
      var target = locs.filter(function (l) { return l.root.classList.contains('ocp-hd-ship') === ship; })[0];
      if (target) drawerClose(function () { locOpen(target); });
    });
    menu.querySelectorAll('[data-ocp-filter]').forEach(function (input) {
      input.addEventListener('input', function () { makesFilter(input); });
      input.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        var hits = makesFilter(input);
        if (hits.length === 1) hits[0].querySelector('a').click();
      });
    });

    /* Смахивание листа влево: закрыть после 25% ширины или быстрее 0,4 px/мс; вертикальная прокрутка — браузеру (touch-action: pan-y). */
    var drag = null;
    var scrolledAt = 0;
    menu.addEventListener('scroll', function (e) { scrolledAt = e.timeStamp; }, true);
    sheet.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'touch' || e.target.closest('input') || e.timeStamp - scrolledAt < 100) return;
      drag = { x: e.clientX, y: e.clientY, px: e.clientX, pt: e.timeStamp, v: 0, dx: 0, on: false };
    });
    sheet.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
      if (!drag.on) {
        if (Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) { drag = null; return; }
        if (dx > -10) return;
        drag.on = true;
        drawer.classList.add('is-dragging');
      }
      drag.v = (e.clientX - drag.px) / Math.max(1, e.timeStamp - drag.pt);
      drag.px = e.clientX;
      drag.pt = e.timeStamp;
      drag.dx = Math.min(0, dx);
      sheet.style.transform = 'translateX(' + drag.dx + 'px)';
      scrim.style.opacity = String(1 + drag.dx / sheet.offsetWidth);
    });
    function dragEnd() {
      var d = drag;
      drag = null;
      if (!d || !d.on) return;
      drawer.classList.remove('is-dragging');
      if (d.v < -0.4 || d.dx < -sheet.offsetWidth * 0.25) drawerClose();
      else { sheet.style.transform = ''; scrim.style.opacity = ''; }
    }
    sheet.addEventListener('pointerup', dragEnd);
    sheet.addEventListener('pointercancel', dragEnd);
  }

  function closePopups() { closeDropdowns(); locClose(false); }
  document.addEventListener('click', function (e) {
    locs.forEach(function (l) { if (!l.root.contains(e.target)) locClose(false, l); });
    dropdowns.forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
  });
})();
